import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@agape/powersync";

const DEFAULT_FEED_LIMIT = 200;

export type ActivityFeedFilter = Record<never, never>;

export interface ActivityFeedOptions {
  limit?: number;
}

/**
 * Local activity feed (PowerSync `activity_recent` bucket, ~90 days).
 * The account's SQLite only contains its buckets (personal scope + shared
 * lists), so re-filtering by user is unnecessary.
 * Canonical order: server_ts DESC (tie-break by UUIDv7 id).
 */
export function getActivityFeedQuery(db: PowerSyncDrizzleDB, options: ActivityFeedOptions = {}) {
  return db
    .select()
    .from(activity_recent)
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Local history for a specific entity (for the entry detail's "History" sheet).
 * deep history (beyond retention) is requested from the API
 * (`GET /api/activity/entity/:type/:id`).
 */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
